import { useCallback, useEffect, useRef, useState } from "react";
import DailyIframe from "@daily-co/daily-js";
import { X, Loader2 } from "lucide-react";

export const openVideoCall = (call) => window.dispatchEvent(new CustomEvent("wz-video", { detail: call }));

const Frame = ({ call, onExit }) => {
  const host = useRef(null);
  const [state, setState] = useState("joining");
  useEffect(() => {
    let f = null;
    let dead = false;
    (async () => {
      const prev = DailyIframe.getCallInstance();
      if (prev) await prev.destroy().catch(() => {});
      if (dead) return;
      f = DailyIframe.createFrame(host.current, {
        iframeStyle: { width: "100%", height: "100%", border: "0" }, showLeaveButton: true, showFullscreenButton: true,
      });
      f.on("joined-meeting", () => setState("in"));
      f.on("left-meeting", () => setState((st) => { if (!String(st).startsWith("err")) onExit(); return st; }));
      f.on("error", (e) => setState(e?.errorMsg === "account-missing-payment-method" ? "err-pay" : "error"));
      f.join({ url: call.url, token: call.token }).catch(() => setState("error"));
    })();
    return () => { dead = true; f?.destroy().catch(() => {}); };
  }, [call, onExit]);
  return (
    <div className="fixed inset-0 z-[200] flex flex-col bg-[#0E1A2B]" data-testid="video-call" data-no-translate>
      <div className="flex items-center justify-between gap-3 px-4 py-2 text-white">
        <div className="min-w-0"><p className="truncate font-heading text-sm font-bold" data-testid="video-call-title">{call.title || "اجتماع مرئي"}</p>
          <p className="text-[10px] text-amber-300" data-testid="video-call-limit-note">تنبيه: الحد المجاني 120 دقيقة يومياً</p></div>
        <div className="flex items-center gap-3 text-xs text-slate-300">
          {state === "joining" && <span className="inline-flex items-center gap-1"><Loader2 className="h-3.5 w-3.5 animate-spin" /> جارٍ الاتصال…</span>}
          {state === "error" && <span className="text-rose-300" data-testid="video-call-error">تعذّر الانضمام — قد تكون الدعوة منتهية</span>}
          {state === "err-pay" && <span className="text-rose-300" data-testid="video-call-error">خدمة الفيديو موقوفة: حساب Daily.co يحتاج إضافة وسيلة دفع</span>}
          <button onClick={onExit} className="rounded-full bg-white/10 p-1.5 hover:bg-white/20" data-testid="video-call-close"><X className="h-4 w-4" /></button>
        </div>
      </div>
      <div ref={host} className="flex-1" />
    </div>
  );
};

export const VideoCallHost = () => {
  const [call, setCall] = useState(null);
  useEffect(() => {
    const h = (e) => setCall(e.detail);
    window.addEventListener("wz-video", h);
    return () => window.removeEventListener("wz-video", h);
  }, []);
  const exit = useCallback(() => setCall(null), []);
  return call ? <Frame call={call} onExit={exit} /> : null;
};
